<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">

        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title> {{"MASCHINESTATE.POSITION.HEADER" | translate}} </mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <div class="stack-wrapper">
                        <div class="background stack" id="wrapper">
                            <img
                                class="cabine-background"
                                id="image"
                                src="../../../../../../assets/images//stickBoomPosition/Angle-Position-Visualization-Slew.svg"
                                alt=""
                                (load)="this.imgLoaded = true"
                            />
                        </div>
                        <ng-container *ngIf="this.imgLoaded == true">
                            <ng-container *ngIf="this.boomStickDataset.dataPoints[7]">
                            <div class="value degree stack" id="kps-online">
                                <div class="kps">
                                    <a>{{"MASCHINESTATE.POSITION.KPS_ONLINE" | translate}}:</a>
                                    <mat-chip class="point" [ngClass]="{'gray': this.boomStickDataset.dataPoints[7].value !== 1 && this.boomStickDataset.dataPoints[7].value !== 0, 'green': this.boomStickDataset.dataPoints[7].value === 1, 'red': this.boomStickDataset.dataPoints[7].value === 0}"></mat-chip>
                                </div>
                            </div>
                            </ng-container>
                            <ng-container *ngIf="this.boomStickDataset.dataPoints[8]">
                            <div class="value degree stack" id="kps-cali">
                                <div class="kps">
                                    <a>{{"MASCHINESTATE.POSITION.KPS_CALIBRATION" | translate}}:</a>
                                    <mat-chip class="point" [ngClass]="{'gray': this.boomStickDataset.dataPoints[8].value !== 1 && this.boomStickDataset.dataPoints[8].value !== 0, 'green': this.boomStickDataset.dataPoints[8].value === 1, 'red': this.boomStickDataset.dataPoints[8].value === 0}"></mat-chip>
                                </div>
                            </div>
                            </ng-container>
                            
                            <div class="value degree stack" id="boom-angle">{{ this.boomStickDataset.dataPoints[0].value != 100794368 ? this.boomStickDataset.dataPoints[0].value : '-' }}°</div>
                            <div class="value degree stack" id="stick-angle">{{ this.boomStickDataset.dataPoints[1].value != 100794368 ? this.boomStickDataset.dataPoints[1].value : '-' }}°</div>

                            <div class="value twodigitmeter stack" id="boom-x-pos">{{ this.boomStickDataset.dataPoints[2].value != 100794368 ? this.boomStickDataset.dataPoints[2].value : '-' }} m</div>
                            <div class="value twodigitmeter stack" id="boom-y-pos">{{ this.boomStickDataset.dataPoints[3].value != 100794368 ? this.boomStickDataset.dataPoints[3].value : '-' }} m</div>
                            <div class="value twodigitmeter stack" id="stick-x-pos">{{ this.boomStickDataset.dataPoints[4].value != 100794368 ? this.boomStickDataset.dataPoints[4].value : '-' }} m</div>
                            <div class="value twodigitmeter stack" id="stick-y-pos">{{ this.boomStickDataset.dataPoints[5].value != 100794368 ? this.boomStickDataset.dataPoints[5].value : '-' }} m</div>
                            <div class="value degree stack" id="slew-angle">{{ this.boomStickDataset.dataPoints[6].value != 100794368 ? this.boomStickDataset.dataPoints[6].value : '-' }}°</div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
